import { Story } from '../types';

interface RealCasesData {
  turtleSoup: {
    [category: string]: Story[];
  };
  scenarioSimulation: any;
  narrative: any;
}

class RealCasesService {
  private static instance: RealCasesService;
  private casesData: RealCasesData | null = null;

  private constructor() {}

  static getInstance(): RealCasesService {
    if (!RealCasesService.instance) {
      RealCasesService.instance = new RealCasesService();
    }
    return RealCasesService.instance;
  }

  async loadRealCases(): Promise<RealCasesData> {
    if (this.casesData) {
      return this.casesData;
    }

    try {
      const response = await fetch('/data/realCases.json');
      if (!response.ok) {
        throw new Error('Failed to load real cases');
      }
      const data = await response.json();
      this.casesData = data;
      return this.casesData as RealCasesData;
    } catch (error) {
      console.error('Error loading real cases:', error);
      return this.getDefaultCases();
    }
  }

  getDefaultCases(): RealCasesData {
    return {
      turtleSoup: {
        反诈类: [
          {
            id: 'fraud_1',
            title: '自证清白的代价',
            surface: '我必须花钱证明自己无罪',
            answer: '冒充公检法诈骗',
            difficulty: 'medium',
            category: '冒充公检法'
          }
        ],
        普法类: [
          {
            id: 'law_1',
            title: '祈福的代价',
            surface: '我在福地祈福，却惹祸上身',
            answer: '在禁止区域升放孔明灯',
            difficulty: 'easy',
            category: '公共安全'
          }
        ]
      },
      scenarioSimulation: {},
      narrative: {}
    };
  }

  // 获取所有分类名
  getCategories(): string[] {
    if (!this.casesData) return [];
    return Object.keys(this.casesData.turtleSoup);
  }

  // 获取全部故事（所有分类）
  getAllStories(): Story[] {
    if (!this.casesData) return [];
    const stories: Story[] = [];
    for (const [category, arr] of Object.entries(this.casesData.turtleSoup)) {
      if (Array.isArray(arr)) {
        stories.push(...arr.map(s => ({ ...s, groupCategory: category })));
      }
    }
    return stories;
  }

  getStoriesByCategory(category: string): Story[] {
    if (!this.casesData) return [];

    if (category === '全部') {
      return this.getAllStories();
    }

    const arr = this.casesData.turtleSoup[category];
    if (Array.isArray(arr)) {
      return arr.map(s => ({ ...s, groupCategory: category }));
    }
    return [];
  }

  getScenarioById(id: string) {
    if (!this.casesData) return null;
    return this.casesData.scenarioSimulation[id];
  }

  getScenarioIds(): string[] {
    if (!this.casesData) return [];
    return Object.keys(this.casesData.scenarioSimulation || {});
  }

  getNarrativeById(id: string) {
    if (!this.casesData) return null;
    return this.casesData.narrative[id];
  }
}

export default RealCasesService.getInstance();
